import { useFetch } from "@common/hook/useFetch";
import { deleteTerminationRequestApiRoute } from "@api-routes/bff";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ACCOUNT_DETAILS_PAGE_URL } from "@constants";

export const useCancelBroadbandScheduled = () => {
    const [deleteScheduledTerminationState, { deleteCall }] = useFetch();
    const { isLoading, error } = deleteScheduledTerminationState;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const { push } = useHistory();

    const handleUndoCancellation = async () => {
        await deleteCall<boolean>(deleteTerminationRequestApiRoute()).then((response) => {
            if (response) {
                push(ACCOUNT_DETAILS_PAGE_URL);
            }
        });

        setIsModalOpen(false);
    };

    return { handleUndoCancellation, isLoading, error, isModalOpen, setIsModalOpen };
};
